import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';

export const getWtsEmployeeNotifyAdm = (payload) => apiActionCreator({
  'endpoint': '/wts/catalog/employee/adm',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_ADM,
    ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_ADM,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_ADM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': payload,
});

export const getWtsEmployeeNotifyEva = (payload) => apiActionCreator({
  'endpoint': '/wts/catalog/employee/eva',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_EVA,
    ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_EVA,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_EVA_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': payload,
});

export const getWtsEmployeeNotifyGes = (payload) => apiActionCreator({
  'endpoint': '/wts/catalog/employee/ges',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_GES,
    ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_GES,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_GES_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': payload,
});

export const getWtsEmployeeNotifyTec = (payload) => apiActionCreator({
  'endpoint': '/wts/catalog/employee/tec',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_EMPLOYEE_NOTIFY_TEC,
    ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_TEC,
    [
      ActionTypes.FETCHED_WTS_EMPLOYEE_NOTIFY_TEC_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': payload,
});
